import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Companies
export const companyService = {
  getAll: (params) => api.get('/companies', { params }),
  getById: (id) => api.get(`/companies/${id}`),
  create: (data) => api.post('/companies', data),
  update: (id, data) => api.put(`/companies/${id}`, data),
  delete: (id) => api.delete(`/companies/${id}`)
};

// Entities
export const entityService = {
  getAll: (params) => api.get('/entities', { params }),
  getById: (id) => api.get(`/entities/${id}`),
  create: (data) => api.post('/entities', data),
  update: (id, data) => api.put(`/entities/${id}`, data)
};

// Directors
export const directorService = {
  getAll: (params) => api.get('/directors', { params }),
  create: (data) => api.post('/directors', data),
  update: (id, data) => api.put(`/directors/${id}`, data),
  delete: (id) => api.delete(`/directors/${id}`)
};

// Shareholders
export const shareholderService = {
  getAll: (params) => api.get('/shareholders', { params }),
  create: (data) => api.post('/shareholders', data),
  update: (id, data) => api.put(`/shareholders/${id}`, data),
  delete: (id) => api.delete(`/shareholders/${id}`)
};

// Relationships
export const relationshipService = {
  getAll: (params) => api.get('/relationships', { params }),
  getTree: (companyId, reportDate) => api.get(`/relationships/tree/${companyId}`, { params: { report_date: reportDate } }),
  create: (data) => api.post('/relationships', data),
  delete: (id) => api.delete(`/relationships/${id}`)
};

// Audit Logs
export const auditLogService = {
  getAll: (params) => api.get('/audit-logs', { params })
};

// Snapshots (per-company, user-entered report date)
export const snapshotService = {
  get: (companyId, reportDate) => api.get(`/snapshots/${companyId}`, { params: { report_date: reportDate } })
};

// Documents
export const documentService = {
  getAll: (params) => api.get('/documents', { params }),
  create: (data) => api.post('/documents', data),
  upload: (companyId, file, description) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/documents/upload', formData, {
      params: { company_id: companyId, description },
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  download: (docId) => api.get(`/documents/${docId}/download`, { responseType: 'blob' }),
  delete: (id) => api.delete(`/documents/${id}`)
};

// Org Chart
export const orgChartService = {
  get: (companyId, reportDate) => api.get(`/org-chart/${companyId}`, { params: { report_date: reportDate } }),
  create: (data) => api.post('/org-chart', data),
  update: (nodeId, data) => api.put(`/org-chart/${nodeId}`, data),
  delete: (nodeId) => api.delete(`/org-chart/${nodeId}`),
  generate: (companyId, reportDate) => api.post(`/org-chart/generate/${companyId}`, null, { params: { report_date: reportDate } })
};

// Reports
export const reportService = {
  generateCompanyProfile: (companyId, format, reportDate) => {
    return api.get(`/reports/company-profile/${companyId}`, {
      params: { format, report_date: reportDate },
      responseType: 'blob'
    });
  }
};

// Company Reminders
export const companyReminderService = {
  getAll: (companyId) => api.get('/company-reminders', { params: { company_id: companyId } }),
  create: (data) => api.post('/company-reminders', data),
  update: (id, data) => api.put(`/company-reminders/${id}`, data),
  delete: (id) => api.delete(`/company-reminders/${id}`)
};

// System Reminders
export const systemReminderService = {
  getAll: () => api.get('/system-reminders'),
  create: (data) => api.post('/system-reminders', data),
  update: (id, data) => api.put(`/system-reminders/${id}`, data),
  delete: (id) => api.delete(`/system-reminders/${id}`)
};

// Reminders Dashboard
export const reminderDashboardService = {
  get: () => api.get('/reminders/dashboard')
};

// Statistics
export const statisticsService = {
  get: () => api.get('/statistics')
};

// Seed Data
export const seedService = {
  seedData: () => api.post('/seed-data')
};

export default api;
